module.exports = __webpack_public_path__ + "static/media/logo-S6.9334c408.png";